<div class="info-box">
  <div>
    <div class="widget-container style2023" style="padding-top: 10px">
      <div class="flex grid-gap-15">
        <div class="flex-shrink-0" style="align-content: end">
          <h2 class="sub-header-bar">Users</h2>
        </div>
        <div class="flex-0-0-240 search-input-wrapper">
          <div class="filter-input-container ui-input-narrow" style="position: relative">
            <span
              class="fa fa-search search-icon"
              style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%)"
            ></span>
            <input
              id="userNameInput"
              #nameInput
              autofocus
              (ngModelChange)="searchTextChanged($event)"
              class="input-text"
              [ngModel]="searchText"
              autocomplete="off"
              name="nameInput"
              style="padding-left: 25px"
              pInputText
              placeholder="Search User"
              spellcheck="false"
              type="text"
            />
          </div>
        </div>
        <div class="flex-grow-1">
          <p-dropdown
            [options]="depts"
            appendTo="body"
            placeholder="Select Department"
            class="filter-dropdown ui-dropdown-narrow"
            [(ngModel)]="selectedDeptId"
            (ngModelChange)="onSelectDept($event)"
          ></p-dropdown>
        </div>

        <div class="flex-grow-1">
          <p-dropdown
            [options]="teams"
            appendTo="body"
            placeholder="Select Team"
            class="filter-dropdown ui-dropdown-narrow"
            [(ngModel)]="selectedTeamId"
            (ngModelChange)="onSelectTeam($event)"
          ></p-dropdown>
        </div>
        <div class="flex-shrink-1" style="line-height: 32px">
          <button
            pButton
            type="button"
            icon="fa ui-icon-restore"
            class="button-style btn-sm ui-tertiary-button ml-2"
            (click)="resetFilters()"
          ></button>
        </div>
        <div class="flex-shrink-1" style="line-height: 32px">
          <p-checkbox
            [(ngModel)]="viewCurrentCaller"
            name="viewCurrentCaller"
            [ngModelOptions]="{ standalone: true }"
            binary="true"
            (onChange)="filterCurrentCallUser()"
            label="View Current Caller"
          ></p-checkbox>
        </div>
      </div>
      <div class="ui-table">
        <div class="ui-table-wrapper" style="height: 300px; overflow-y: auto">
          <table *ngIf="filteredUsersInfo" class="w-100 table-striped user-table">
            <thead class="ui-table-thead" style="position: sticky; top: 0">
              <tr>
                <th class="text-left">User Name</th>
                <th class="text-left">Contact Number(s)</th>
                <th class="text-left">Default Team</th>
                <th class="text-left">Associated Departments</th>
                <th class="text-left">Associated Teams</th>
                <th class="text-left">Action</th>
              </tr>
            </thead>
            <tbody class="ui-table-tbody">
              <tr *ngFor="let info of filteredUsersInfo">
                <td>{{ info.userName }}</td>
                <td>
                  <div *ngFor="let number of info.phoneNumbers">
                    {{ number }}
                  </div>
                </td>
                <td>{{ info.defaultTeamName }}</td>
                <td>
                  {{ info.associatedDeptsCount }} Department<span
                    *ngIf="info.associatedDeptsCount > 1"
                    >s</span
                  >
                </td>
                <td>
                  {{ info.associatedTeamsCount }} Team<span *ngIf="info.associatedTeamsCount > 1"
                    >s</span
                  >
                </td>
                <td
                  style="cursor: pointer; color: var(--engineius-blue)"
                  (click)="showUserOrgStructure(info)"
                >
                  Structure Details <i class="fa fa-sitemap" aria-hidden="true"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="User Organisation"
  [(visible)]="userOrgDialogVisible"
  [style]="{ height: '500px', width: '600px' }"
  [responsive]="true"
  [modal]="true"
>
  <div *ngIf="!loadingOrgStructure && userOrgStructure; else loadingStructure">
    <div class="header-line">
      The departments/teams that <span class="header-user">{{ selectedUserName }}</span> is a part
      of.
    </div>

    <div class="all-teams" [class.disabled]="!isAllTeamsAccess">
      <p-checkbox
        class="style2023"
        [value]="isAllTeamsAccess"
        readonly="true"
        label="All Teams"
        binary="true"
      >
      </p-checkbox>
    </div>

    <div class="structure-container">
      <div class="org-structure">
        <div *ngFor="let department of userOrgStructure.departments" class="department">
          <div (click)="toggleDepartment(department)" class="department-header">
            <span *ngIf="department.expanded" class="chevron-icon"
              ><i class="fa fa-chevron-down"></i
            ></span>
            <span *ngIf="!department.expanded" class="chevron-icon"
              ><i class="fa fa-chevron-up"></i
            ></span>
            <p-checkbox
              class="style2023"
              readonly="true"
              [label]="department.name"
              [ngModel]="true"
              binary="true"
            >
            </p-checkbox>
          </div>
          <div *ngIf="department.expanded" class="teams">
            <div *ngFor="let team of getTeamsForDepartment(department)" class="team">
              <p-checkbox
                class="style2023"
                readonly="true"
                [label]="team.name"
                [ngModel]="true"
                binary="true"
              >
              </p-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="default-team">
      <div class="flex-1 default-team-label">Default Team:</div>
      <div class="flex-1 default-team-value">{{ defaultTeam?.name || 'Not Set' }}</div>
    </div>
  </div>

  <ng-template #loadingStructure>
    <div style="height: 300px; line-height: 300px; text-align: center">
      <i class="fa fa-spinner fa-spin fa-2x"></i>&nbsp; Loading
    </div>
  </ng-template>
</p-dialog>
